import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import {
    RaceOverviewData,
    RaceOverviewDataItem,
    RaceOverviewDetails,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RunnerDetails.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

interface RunnerDetailsPropsType {
    selectionId: SelectionId;
}

export const RunnerDetails = observer('RunnerInformation', ({ selectionId }: RunnerDetailsPropsType) => {
    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const eventModel = selectionModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const common = useCommon();
    const isTablet = BreakpointsState.get(common).tablet.isBiggerOrEq;

    const horseWeightRaw = selectionModel.metaDataWeight ?? '';
    const horseWeightFormatted = horseWeightRaw.trim() === '' ? 'n/a' : horseWeightRaw;

    const horseAgeRaw = selectionModel.metaDataAge ?? '';
    const horseAgeFormatted = horseAgeRaw.trim() === '' ? 'n/a' : horseAgeRaw;

    const horseFormRaw = selectionModel.metaDataForm ?? '';
    const horseFormFormatted = horseFormRaw.trim() === '' ? 'n/a' : horseFormRaw;

    const desktopView = (
        <>
            <div>
                <RaceOverviewDataItem>
                    <I18n
                        langKey='events.race-summary.race-details.weight'
                        defaultText='Weight'
                    />
                    : {horseWeightFormatted}
                </RaceOverviewDataItem>
                <RaceOverviewDataItem>
                    <I18n
                        langKey='events.race-summary.race-details.age'
                        defaultText='Age'
                    />
                    : {horseAgeFormatted}
                </RaceOverviewDataItem>
            </div>
            <div>
                <I18n
                    langKey='events.race-summary.race-details.form'
                    defaultText='Form'
                />
                : <RaceOverviewDetails>{horseFormFormatted}</RaceOverviewDetails>
            </div>
        </>
    );

    const mobileView = (
        <>
            <I18n
                langKey='events.race-summary.race-details.form'
                defaultText='Form'
            />
            : <RaceOverviewDetails>{horseFormFormatted}</RaceOverviewDetails>
            <RaceOverviewDataItem>
                <I18n
                    langKey='events.race-summary.race-details-mobile'
                    defaultText='W'
                />
                : {horseWeightFormatted}
            </RaceOverviewDataItem>
            <RaceOverviewDataItem>
                <I18n
                    langKey='events.race-summary.race-details.age'
                    defaultText='Age'
                />
                : {horseAgeFormatted}
            </RaceOverviewDataItem>
        </>
    );

    return <RaceOverviewData>{isTablet === true ? desktopView : mobileView}</RaceOverviewData>;
});
